<ng-template #itemTemp let-r="result" let-t="term">
  <div>
    <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
  </div>
</ng-template>
<input
  id="itemTypeAhead"
  [disabled]="itemBusy"
  [editable]="false"
  type="text"
  autocomplete="off"
  class="form-control form-control-sm"
  [inputFormatter]="formatter"
  [resultFormatter]="formatter"
  placeholder="Search Product / Item"
  [resultTemplate]="itemTemp"
  [ngbTypeahead]="search"
  (selectItem)="onItemSelect($event.item)"
  #itemTypeAhead
/>
